import type { GridMapboxStyle } from './styles';

export const gridsUnit = (style: GridMapboxStyle) => [
  {
    minzoom: 11,
    layout: {
      'text-field': ['get', 'label'],
      'text-size': style.textSize,
      'text-ignore-placement': false,
      'text-allow-overlap': false,
      visibility: 'visible',
    },
    type: 'symbol',
    id: 'nts-unit-labels',
    paint: {
      'text-color': style.textColor,
      ...(style.textHaloColor &&
        style.textHaloWidth && {
          'text-halo-color': style.textHaloColor,
          'text-halo-width': style.textHaloWidth,
        }),
    },
    source: 'grids',
    'source-layer': 'unit_centers',
  },
  {
    id: 'nts-unit-grid',
    minzoom: 11,
    type: 'line',
    paint: {
      'line-color': style.lineColor,
      'line-width': style.lineWidth,
    },
    source: 'grids',
    'source-layer': 'unit',
    layout: {
      visibility: 'visible',
    },
  },
];
